export const UtilityStatusType = {
  Pending: 'Pending',
  Failed: 'Failed',
  Success: 'Success'
};
